import { workplaceAppRatingPromptEventContract } from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation } from "@tanstack/react-query";
import { type z } from "zod";

/**
 * Event payload the caller supplies, including the `idempotencyId` — derived
 * per session in `ReviewPromptItem` (D-07) and passed through, not minted here.
 */
export type RecordRatingPromptEventInput = z.input<
  typeof workplaceAppRatingPromptEventContract.recordEvent.body
>;

/**
 * Records a first-party rating-prompt engagement event over the same-origin
 * API, alongside the existing Knock marks and `logEvent` calls, never instead
 * of them. Failures are silent (analytics write, no user-facing surface) and
 * only log via `meta.logErrorMessage`.
 */
export function useRecordRatingPromptEvent() {
  return useMutation({
    mutationFn: async (event: RecordRatingPromptEventInput) => {
      const response = await post({
        url: `${environmentConfig.REACT_APP_API_MAIN_URL}${workplaceAppRatingPromptEventContract.recordEvent.path}`,
        data: event,
        bodySchema: workplaceAppRatingPromptEventContract.recordEvent.body,
        responseSchema: workplaceAppRatingPromptEventContract.recordEvent.responses[200],
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.RATING_PROMPT_EVENT_RECORD_FAILURE,
    },
  });
}
